<template>
    <section class="bg-auth-home d-table w-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7 col-md-6">
                    <div class="me-lg-5">
                        <img src="/assets/images/user/recovery.svg" class="img-fluid d-block mx-auto" alt="">
                    </div>
                </div>
                <div class="col-lg-5 col-md-6">
                    <div class="card shadow rounded border-0">
                        <div class="card-body">
                            <h4 class="card-title text-center">Restore password</h4>
                            <p class="sub-title mb-3">Did you forget your password?</p>
                            <form class="login-form mt-4" @submit.prevent="reset()">
                                <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" role="alert">
                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="error = null"></button>
                                    <strong>{{error}}</strong>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label class="form-label">Email</label>
                                            <div class="form-icon position-relative">
                                                <i data-feather="mail" class="fea icon-sm icons"></i>
                                                <input type="tel" class="form-control ps-5" id="login-email" placeholder=""
                                                       aria-label="email" aria-describedby="email" v-model="user.email" dir="ltr" required="">
                                            </div>
                                        </div>
                                    </div><!--end col-->
                                    <div class="col-md-12">
                                        <div class="d-grid">
                                            <button class="btn btn-primary" type="submit">Send verification code</button>
                                        </div>
                                    </div><!--end col-->
                                </div><!--end row-->
                            </form>
                        </div>
                    </div>
                </div> <!--end col-->
            </div><!--end row-->
        </div> <!--end container-->
    </section><!--end section-->
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    inject: ['auth'],
    data() {
        return {
            user: {},
            error: null,
        }
    },
    methods: {
        reset() {
            const that = this;
            this.error = null;
            const id = toast.info('Verification code is being sent.', {
                icon: 'fa-solid fa-comment-sms'
            });

            axios.post('/password/email', this.user)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, {
                        timeout: 3000,
                        icon: 'fa-solid fa-circle-check'
                    });
                    // that.$router.push({ name: 'password.change' , query: { 'email': that.user.email }});

                }).catch(function (error) {

                toast.dismiss(id);
                that.error = error.response?.data?.message;
            });
        }
    },
}
</script>
